import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { ModalComponent } from '@styleguide/modal/modal/modal.component';
import { ModalHeaderComponent } from '@styleguide/modal/modal-header/modal-header.component';
import { ModalContentComponent } from '@styleguide/modal/modal-content/modal-content.component';
import { ModalFooterComponent } from '@styleguide/modal/modal-footer/modal-footer.component';

@Component({
  selector: 'kgr-confirmation-modal',
  imports: [ModalComponent, ModalHeaderComponent, ModalContentComponent, ModalFooterComponent],
  templateUrl: './confirmation-modal.component.html',
  styleUrl: './confirmation-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationModalComponent {
  @Output() confirmConfirmation = new EventEmitter<void>();
  @Output() declineConfirmation = new EventEmitter<void>();
  @Output() cancelConfirmation = new EventEmitter<void>();

  @Input({ required: true }) show = false;

  @Input() showDeclineButton = false;

  @Input() cancelButtonLabel = $localize`Abbrechen`;
  @Input() confirmButtonLabel = $localize`Ja`;
  @Input() declineButtonLabel = $localize`Nein`;

  @Input() confirmButtonCssClass = 'kgr-button--accent';
  @Input() declineButtonCssClass = 'kgr-button--accent';

  @Input() headline = $localize`Bitte bestätigen`;
  @Input() text = $localize`Sind Sie sicher?`;

  @Input()
  fullWidth = false;

  @Input()
  fullHeight = false;

  @Input()
  width?: string;

  @Input()
  height?: string;

  @Input() loading = false;

  cancel() {
    this.cancelConfirmation.emit();
  }

  confirm() {
    this.confirmConfirmation.emit();
  }

  decline() {
    this.declineConfirmation.emit();
  }
}
